/**
 * Paiement et portefeuille — mise en forme des données du serveur pour le
 * design « Paiement et portefeuille.dc.html ».
 *
 *   GET /customer/wallet           → { wallet: { amount, wallet_entries } }
 *   GET /customer/payment_methods  → { payment_method: [{ id, brand, last4, exp_year, … }] }
 *
 * Le serveur ne dit pas par quel moyen une ligne a été payée ni si c'est une
 * recharge ou un remboursement : le sens du montant fait la différence
 * (crédit = recharge ou remboursement, débit = commande), comme le filtre
 * « Recharges » du design qui regroupe tout ce qui n'est pas une commande.
 */

export const TOPUP_AMOUNTS = [20, 50, 100, 200];
/** Minimum imposé par le prestataire de paiement (MIN_TOPUP du mobile). */
export const MIN_TOPUP = 0.5;

/** Montant saisi à la belge (« 12,50 ») ou à l'anglaise ; 0 si illisible. Arrondi au centime. */
export const parseTopup = (raw) => {
  const n = parseFloat(String(raw ?? "").replace(/\s|€/g, "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0;
};

export const HISTORY_PAGE = 5;

const toNumber = (value) => {
  const n = parseFloat(String(value ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const formatEuro = (value) => `€${Math.abs(toNumber(value)).toFixed(2).replace(".", ",")}`;

/** « 13/01/2025 » en heure locale. */
export function formatDay(raw) {
  const d = raw ? new Date(raw) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** Lignes d'historique, les plus récentes d'abord (ordre du serveur). */
export function historyRows(entries = [], filter = "all") {
  return (entries || [])
    .map((entry) => {
      const value = toNumber(entry?.entry_amount);
      return {
        id: entry?.id,
        label: String(entry?.description || "").trim(),
        date: formatDay(entry?.created_at),
        credit: value > 0,
        amount: `${value > 0 ? "+" : "−"}${formatEuro(value)}`,
        value,
      };
    })
    .filter((row) => row.value !== 0)
    .filter((row) => filter === "all" || (filter === "topup" ? row.credit : !row.credit));
}

const BRANDS = { visa: "VISA", mastercard: "MC", amex: "AMEX", american_express: "AMEX", bancontact: "BCMC" };

/** Pastille de marque : « VISA », « MC »… */
export const brandLabel = (brand) => {
  const key = String(brand || "").toLowerCase().replace(/\s+/g, "_");
  return BRANDS[key] || String(brand || "").toUpperCase().slice(0, 4) || "CARD";
};

/** « 08/28 » quand le mois est connu, sinon l'année seule (le serveur n'envoie que exp_year). */
export function cardExpiry(card) {
  const year = card?.exp_year ? String(card.exp_year) : "";
  const month = card?.exp_month ? String(card.exp_month).padStart(2, "0") : "";
  if (month && year) return `${month}/${year.slice(-2)}`;
  return year;
}
